/* eslint-disable no-restricted-syntax */
import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/notaDePedido`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const fetchNotasDePedido = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  // Obtén el valor del parámetro "sort"
  const sortParam = query.get("sort");
  if (sortParam) {
    // Agrega los nuevos parámetros "orderBy" y "orderType"

    query.set("orderBy", sortParam);
    query.set("orderType", "ASC");
  }
  // Verifica si el parámetro "sort" tiene un signo menos (-)
  if (sortParam && sortParam.startsWith("-")) {
    // Remueve el signo menos (-) y obtén el valor de "sort"
    const sortValue = sortParam.substring(1);

    // Agrega los nuevos parámetros "orderBy" y "orderType"
    query.set("orderBy", sortValue);
    query.set("orderType", "DESC");
  }
  query.delete("sort");

  let res = await fetch(readUrl(`?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchNotasDePedidoActivas = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  // Obtén el valor del parámetro "sort"
  const sortParam = query.get("sort");
  if (sortParam) {
    // Agrega los nuevos parámetros "orderBy" y "orderType"

    query.set("orderBy", sortParam);
    query.set("orderType", "ASC");
  }
  // Verifica si el parámetro "sort" tiene un signo menos (-)
  if (sortParam && sortParam.startsWith("-")) {
    // Remueve el signo menos (-) y obtén el valor de "sort"
    const sortValue = sortParam.substring(1);

    // Agrega los nuevos parámetros "orderBy" y "orderType"
    query.set("orderBy", sortValue);
    query.set("orderType", "DESC");
  }
  query.delete("sort");

  let res = await fetch(readUrl(`/list?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

// para export de notas de pedido
export const downloadNotasDePedido = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  const res = await fetch(readUrl(`/export?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  const blob = await res.blob();
  return blob;
};

export const fetchNotaDePedidoById = async (itemId, params) => {
  // aca agrego las querys para obtener del back el orden de los tickets filtrados.
  const query = params ? new URLSearchParams(params) : null;

  const auth = `Bearer ${getToken()}`;

  if (itemId && itemId !== "undefined") {
    let res = await fetch(readUrl(`/${itemId}?${query && query.toString()}`), {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
    });

    res = await parseJSON(res);
    return res.success;
  }
  // si no hay itemId retornar un array vacio
  return [];
};

export const postNotaDePedido = async (notaDePedido) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(``), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(notaDePedido),
  });

  res = await parseJSON(res);

  return res.success;
};

export const getNotasDePedidoCategory = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/category`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};

export const getNotasDePedidoBySubclientId = async (id) => {
  const auth = `Bearer ${getToken()}`;
  if (!id || id === "undefined") return [];

  let res = await fetch(readUrl(`/bySubclient?subClienteId=${id}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};

export const getPosicionesNp = async () => {
  // se puede agregar query para search y sort
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/posiciones`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};

export const patchNotaDePedido = async (itemId, notaDePedido) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${itemId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(notaDePedido),
  });

  res = await parseJSON(res);

  return res.success;
};

export const postNotaDePedidoV2 = async (notaDePedido) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/new`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(notaDePedido),
  });

  res = await parseJSON(res);

  return res.success;
};

export const exportarHistoricoNotasDePedido = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  const res = await fetch(readUrl(`/exportHistorico?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  const response = await res.json();

  return response;
};

// para export de avisos
export const exportAvisos = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  const res = await fetch(readUrl(`/exportAvisosNP?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  const blob = await res.blob();
  return blob;
};
